import AppSetting from './AppSetting'
import Employee from './Employee'
export class SaveAppSettingRequest {
    AppSetting: AppSetting;
    SavedByEmployee: Employee;
}

export default SaveAppSettingRequest;